import { Injectable, Pipe, PipeTransform } from '@angular/core';

const emojiDictionary = [
    { patterns: [':)', ':-)', '=)'], unicode: '😃' },
    { patterns: [';)', ';-)'], unicode: '😉' },
    { patterns: [':D', ':-D', '=D'], unicode: '😀' },
    { patterns: [':(', ':-(', '=('], unicode: '🙁' },
    { patterns: [':|', ':-|', '=|'], unicode: '😐' },
    { patterns: [':*', ':-*', '=*'], unicode: '😙' },
    { patterns: ['T_T', 'T.T'], unicode: '😭' },
    { patterns: [':O', ':-O', '=O', ':o', ':-o', '=o'], unicode: '😮' },
    { patterns: [':P', ':-P', '=P', ':p', ':-p', '=p'], unicode: '😋' },
    { patterns: ['>.<'], unicode: '😣' },
    { patterns: ['@.@'], unicode: '😵' },
    { patterns: ['*.*'], unicode: '😍' },
    { patterns: ['<3'], unicode: '❤️' },
    { patterns: ['^.^'], unicode: '😊' },
    { patterns: [':+1'], unicode: '👍' },
    { patterns: [':-1'], unicode: '👎' }
];

/*
 * Transforms common emoji text to UTF encoded emojis
*/
@Pipe({standalone: true, name: 'emojify'})
@Injectable({
    providedIn: 'root'
})
export class EmojifyPipe implements PipeTransform {
    public transform(message: string): string {
        if (message && message.length > 1) {
            emojiDictionary.forEach((emoji) => {
                emoji.patterns.forEach((pattern) => {
                    message = message.replace(pattern, emoji.unicode);
                });
            });
        }

        return message;
    }
}
